import {PRODUCTION_MODE} from "./Functions";
export const detectPathUrl = (path) => (PRODUCTION_MODE ? `/agent/${path}` : `/${path}`)
